import { type FunctionComponent } from 'react';
import { ErrorRecovery } from '../../components/ErrorRecovery/ErrorRecovery';

export type ErrorRecoveryPageProps = {
  children?: never;
};

export const ErrorRecoveryPage: FunctionComponent<
  ErrorRecoveryPageProps
> = () => {
  // TODO: Import useTitle
  // useTitle('error_recovery');

  return <ErrorRecovery />;
};
